import React from "react";
import { Star } from "lucide-react";
import type { StarRatingProps } from "./types";

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  hoveredRating,
  isSubmitting,
  onRatingChange,
  onHover,
  onHoverLeave,
}) => {
  const displayRating = hoveredRating || rating;

  return (
    <div className="flex gap-1 sm:gap-2 mb-3 sm:mb-4 justify-center">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className="focus:outline-none transition-transform hover:scale-110 active:scale-95 cursor-pointer disabled:cursor-not-allowed"
          onMouseEnter={() => onHover(star)}
          onMouseLeave={onHoverLeave}
          onClick={() => onRatingChange(star)}
          disabled={isSubmitting}
        >
          <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center">
            <Star
              size={28}
              fill={star <= displayRating ? "#FFC107" : "transparent"}
              color={star <= displayRating ? "#FFC107" : "#CBD5E1"}
              strokeWidth={2}
            />
          </div>
        </button>
      ))}
    </div>
  );
};

